/** Тело POST questions: узел Libre, вес 1…5, обёрнутый ключ вопроса и шифротекст данных */
export class CreateQuestionParams {
  node: string
  weight: number
  key: string
  data: string

  constructor({ node, weight, key, data }: { node: string, weight: number, key: string, data: string }) {
    this.node = node
    this.weight = weight
    this.key = key
    this.data = data
  }
}
